module.exports = __webpack_public_path__ + "static/media/journal_tab.65e35370.png";